// Add debugging
console.log('Loading AccessToken enum')

export enum AccessToken {
  Access = 'ACCESS_TOKEN',
  Refresh = 'REFRESH_TOKEN',
  Temporary = 'TEMPORARY_ACCESS_TOKEN',
}
